'use client';

import clsx from 'clsx';

export default function Banana({ reset }: { reset: () => void }) {
  return (
    <div
      id="nw-50x"
      className={clsx(
        'bg-error-image',
        'h-full',
        'bg-[#65a989]',
        'm-0',
        'p-0',
        'min-h-screen',
        'bg-center',
        'bg-cover',
        'bg-no-repeat',
        'text-center',
        'font-gotham',
        'leading-6',
        'flex',
        'flex-col',
        'content-center',
      )}
    >
      <div
        id="nw-heading-wrap"
        className={clsx('min-h-[100px]', 'absolute', 'top-[22vh]', 'w-full')}
      >
        <h1
          className={clsx(
            'text-white',
            'my-0',
            'mx-auto',
            'tracking-[-0.67px]',
            'max-w-[350px]',
            'block',
          )}
        >
          Sorry, looks like something slipped up.
        </h1>
      </div>
      <div className={clsx('absolute', 'w-full', 'top-[77vh]')}>
        <button
          className={clsx(
            'cursor-pointer',
            'no-underline',
            'hover:no-underline',
            'hover:text-[#005fb9]',
            'focus:text-[#005fb9]',
            'visited:text-[#005fb9]',
            'active:text-[#005fb9]',
            'focus:outline-2',
            'focus:outline',
            'focus:outline-[#4b99e6]',
            'focus:outline-offset-4',
            'text-[#fff]',
            'bg-[#6cc551]',
            'py-[7px]',
            'px-[40px]',
            'h-[40px]',
            'rounded',
            'tracking-[-0.34px]',
            'no-underline',
            'hover:shadow-[0_2px_5px_0_rgba(0,0,0,0.2)]',
          )}
          type="button"
          onClick={reset}
        >
          Let&apos;s try that again!
        </button>
      </div>
    </div>
  );
}
